import React from 'react';

const PLACEHOLDER_ROWS = Object.freeze(['primary', 'secondary', 'tertiary']);

/** Reserve canonical Project-row geometry while the sidebar projection is unresolved. */
export default function SessionListLoadingSkeleton() {
  return (
    <div aria-hidden="true" className="flare-session-list-loading-skeleton">
      {PLACEHOLDER_ROWS.map((rowKey) => (
        <div className="flare-project-row flare-session-list-loading-skeleton-row" key={rowKey}>
          <span className="flare-session-list-loading-skeleton-shape is-icon" />
          <span className="flare-session-list-loading-skeleton-copy">
            <span className="flare-session-list-loading-skeleton-shape is-title" />
            <span className="flare-session-list-loading-skeleton-shape is-meta" />
          </span>
        </div>
      ))}
    </div>
  );
}
